import { create } from "zustand";
import {
  WorkflowContainerFullI,
  WorkflowContainerFullActionI,
  WorkflowI,
  WorkflowActionI,
} from "../../../libs/interfaces";
import { createWorkflowContainerFullSlice } from "./workflow-container-full.store";
// import { createJSONStorage, persist } from "zustand/middleware";
import { persist } from "zustand/middleware";
import { createWorkflowFSlice } from "./workflow.store";
// import { unifiedZustandStorage } from '../../../libs/helpers';
// const storage = unifiedZustandStorage;

export const useWorkflowContainerFullStore = create<
  WorkflowContainerFullI &
    WorkflowContainerFullActionI &
    WorkflowI &
    WorkflowActionI
>()(
  persist(
    (...a) => ({
      ...createWorkflowFSlice(...a),
      ...createWorkflowContainerFullSlice(...a),
    }),
    {
      name: "workflow-container-full-puce-1",
      // storage: createJSONStorage(() => storage),
      
    }
  )
);


